import React from "react";
import { Link } from "react-router-dom";

//import components
import SidebarContent from "./SidebarContent";
import { useAppSelector } from "src/store";
import images from "src/assets/image";

const Sidebar = (props: any) => {
  const user = useAppSelector((s) => s.auth.user);
  const fullName =
    user && (user.Name || user.Surname)
      ? `${user.Name ?? ""} ${user.Surname ?? ""}`.trim()
      : user?.UserName || "Rentificial";
  const sub = user?.Email || user?.UserName || "admin";
  const avatar = user?.ProfileImage || images.avatar;

  return (
    <React.Fragment>
      <div className="vertical-menu">
        <div data-simplebar className="h-100">
          {props.type !== "condensed" ? <SidebarContent /> : <SidebarContent />}
        </div>

        <div className="sidebar-user">
          <img className="sidebar-user__avatar" src={avatar} alt="" />
          <div className="sidebar-user__info">
            <span className="sidebar-user__name">{fullName}</span>
            <span className="sidebar-user__sub">{sub}</span>
          </div>
          <Link
            to="/logout"
            className="sidebar-user__logout"
            title="Logout"
          >
            <i className="mdi mdi-logout" />
          </Link>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Sidebar;
